import React from 'react';
import Slider from "react-slick";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    arrows: false,
    slidesToScroll:1,
    rtl: true,

    responsive: [
        {
          breakpoint: 1200,
          settings: {
            rtl: true,
            initialSlide: 1,
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            autoplay: true,
            autoplaySpeed: 1500,
            pauseOnHover: false,
            arrows: false,
            slidesToScroll:1,
          }
        },
        {
          breakpoint: 860,
          settings: {
            rtl: true,
            initialSlide: 1,
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            autoplay: true,
            autoplaySpeed: 1500,
            pauseOnHover: false,
            arrows: false,
            slidesToScroll:1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            rtl: true,
            initialSlide: 1,
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 1500,
            pauseOnHover: false,
            arrows: false,
            slidesToScroll:1,
          }
        }
    ]
  };

const HomepageSlider = (props: any) => {
    return(
        <div className="streamCards__container">
        <Slider {...settings}>
            {props.children}
        </Slider>
        </div>

    )
}

export default HomepageSlider;